import { useQuery } from "@tanstack/react-query";

import { useAuth } from "@/auth/AuthProvider";
import { api } from "@/lib/api";

type UserRow = {
  id: number;
  email: string;
  full_name: string;
  role: string;
  active: boolean;
  last_login_at: string | null;
};

export function UsersPage() {
  const { user } = useAuth();
  const isAdmin = user?.role === "admin";

  const { data, isLoading } = useQuery({
    queryKey: ["users"],
    queryFn: async () => (await api.get<UserRow[]>("/users")).data,
    enabled: isAdmin,
  });

  if (!isAdmin) {
    return <div className="text-gray-600">Chỉ admin mới xem được trang này.</div>;
  }

  return (
    <div className="p-6 max-w-[1600px] mx-auto">
      <h1 className="text-xl font-semibold text-slate-900 mb-5">Người dùng</h1>
      {isLoading && <div className="text-gray-500">Đang tải...</div>}
      {data && (
        <table className="w-full bg-white border border-gray-200 text-sm">
          <thead className="bg-gray-50">
            <tr>
              <th className="text-left px-3 py-2">Email</th>
              <th className="text-left px-3 py-2">Họ tên</th>
              <th className="text-left px-3 py-2">Vai trò</th>
              <th className="text-left px-3 py-2">Hoạt động</th>
              <th className="text-left px-3 py-2">Đăng nhập cuối</th>
            </tr>
          </thead>
          <tbody>
            {data.map((u) => (
              <tr key={u.id} className="border-t border-gray-100">
                <td className="px-3 py-2">{u.email}</td>
                <td className="px-3 py-2">{u.full_name}</td>
                <td className="px-3 py-2 font-mono text-xs">{u.role}</td>
                <td className="px-3 py-2">{u.active ? "✓" : "—"}</td>
                <td className="px-3 py-2 text-gray-500 text-xs">
                  {u.last_login_at ? new Date(u.last_login_at).toLocaleString("vi-VN") : "—"}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}
